import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { WHO_WE_TREAT, PAGE_BANNERS } from "../data/content";

export default function WhoWeTreat() {
  // Split into 2 columns for visual balance
  const half = Math.ceil(WHO_WE_TREAT.length / 2);
  const col1 = WHO_WE_TREAT.slice(0, half);
  const col2 = WHO_WE_TREAT.slice(half);
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.services} alt="Who We Treat" fallbackKey="services" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h2 className="!text-2xl !mt-0">
            Some of the conditions we can help you address, but are not limited to, the following:
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8">
            <ul>
              {col1.map((c) => (
                <li key={c}>{c}</li>
              ))}
            </ul>
            <ul>
              {col2.map((c) => (
                <li key={c}>{c}</li>
              ))}
            </ul>
          </div>
        </article>
      </div>
    </div>
  );
}
